import React from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import MultiSelectionInput from '../../common/MultiSelectionInput';
import { toast } from 'react-toastify';

const AttachMagazineSurveyModal = ({
  articleSearch,
  selectedArticles,
  activeArticleDropdown,
  surveyList,
  handleArticleSearch,
  handleArticleSelect,
  handleAttachMagazineSurvey,
  clearSelections,
  handleRemoveArticle
}) => {
  return (
    <div className="p-4">
      <h5 className="text-primary mb-3">Attach Articles to Magazine Survey</h5>

      <MultiSelectionInput
        label="Please select articles"
        placeholder="Search Articles"
        value={articleSearch}
        onSearch={handleArticleSearch}
        onSelect={handleArticleSelect}
        onClear={clearSelections}
        results={surveyList.articles}
        isActive={activeArticleDropdown}
        onFocus={() => handleArticleSearch(articleSearch)}
        selectedItems={selectedArticles}
        onRemoveItem={handleRemoveArticle}
      />

      <Button
        color="primary"
        onClick={() => {
          if (!selectedArticles || selectedArticles.length === 0) {
            toast.error("Please select at least one article");
            return;
          }
          handleAttachMagazineSurvey();
        }}
      >
        Attach Articles
      </Button>
    </div>
  );
};

export default AttachMagazineSurveyModal; 